import { useProductStatus } from './useProductStatus.hook';
import { isAragServiceActive } from '@/components/content/benefits/modals/aragModal/aragServiceConfig';
import { InsuranceServiceName } from '@/@types/insurance';
import type { InsurancePackageState } from '@/@types/insurance';
import { ProductsStatusKey } from '@/@types/productsStatus';

export const useInsurancePackageStatus = () => {
  const insurancePackage = useProductStatus(ProductsStatusKey.insurancePackage) as InsurancePackageState;

  return {
    isRechtsberatungEntitled: isAragServiceActive(insurancePackage, InsuranceServiceName.RECHTSBERATUNG),
    isMietrechtsschutzEntitled: isAragServiceActive(insurancePackage, InsuranceServiceName.MIETRECHTSSCHUTZ),
    isMediationEntitled: isAragServiceActive(insurancePackage, InsuranceServiceName.MEDIATION),
    isSchluesseldienstEntitled: isAragServiceActive(insurancePackage, InsuranceServiceName.SCHLUESSELDIENST),
    insurancePackageStatus: insurancePackage?.status,
    insurancePackageType: insurancePackage?.type,
  };
};

export const useIsServiceActive = (serviceName: InsuranceServiceName) => {
  const insurancePackage = useProductStatus(ProductsStatusKey.insurancePackage) as InsurancePackageState;
  return isAragServiceActive(insurancePackage, serviceName);
};
